import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
export const AdminPageHeader = ({ title, children, actions, }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    return (_jsx(Box, { sx: {
            position: "sticky",
            left: { xs: 8, sm: 8, md: 24 },
            right: { xs: 8, sm: 8, md: 24 },
            px: 3,
            background: theme.palette.common.white,
            height: 'auto',
            zIndex: 21,
            borderBottomRightRadius: "24px",
            borderBottomLeftRadius: "24px",
        }, mb: 1.5, children: actions && actions }));
};
